import { Card, Divider, Grid, Typography } from "@mui/material"
import Box from '@mui/material/Box';
import React from "react"
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import DownloadIcon from '@mui/icons-material/Download';
import '../Previous.css';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

export default function Previous() {
  return (
    <Box className="pyq-gl">
    <Box>
    <div className="dashboard-card" >
     <Typography variant="h2" sx={{textAlign:'center', marginBottom:4}}>Sample Papers</Typography>
      <div class="container">
			<div class="card">
				<div class="content">
					<div class="">
            <h3>POOL A</h3>
					</div>
					<div class="contentBx">
						<h3><span>Class 6th to 8th</span></h3>
					</div>
				</div>
				<div class="sci" >
					
						<div class = "sci-next"><button class="button-5 button-prev"><a href="Pool-A.pdf" download>Download</a></button></div>
				
				</div>
			</div>
			<div class="card">
      <div class="content">
					<div class="">
            <h3>POOL B</h3>
					</div>
					<div class="contentBx">
						<h3><span>Class 9th to 10th</span></h3>
					</div>
				</div>
				<div class="sci" >
					
						<div class = "sci-next"><button class="button-5 button-prev"><a href="Pool-B.pdf" download>Download</a></button></div>
				
				</div>
				
			</div>
			<div class="card">
      <div class="content">
					<div class="">
            <h3>POOL C</h3>
					</div>
					<div class="contentBx">
						<h3><span>Class 11th to 12th</span></h3>
					</div>
				</div>
				<div class="sci" >
					
						<div class = "sci-next"><button class="button-5 button-prev"><a href="Pool-C.pdf" download>Download</a></button></div>
				
				</div>
			</div>
		</div>
      </div>
     </Box>
    </Box>
  )
}